import React from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import { Breadcrumb, Modal, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import moment from 'moment';
import _ from 'lodash';

import TablaAcuerdosExtrajudiciales from './TablaAcuerdosExtrajudiciales.js';
import { descargarCSV } from '../../../components/administracion/funciones/descargarCSV';

// GRAPHQL
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getCantidadAcuerdosExtrajudicialesConFiltros from '../../../graphql/querys/arreglosExtrajudiciales/getCantidadAcuerdosExtrajudicialesConFiltros.graphql';
import getAcuerdosExtrajudicialesConFiltros from '../../../graphql/querys/arreglosExtrajudiciales/getAcuerdosExtrajudicialesConFiltros.graphql';
import getAcuerdosExtrajudicialesPorRango from '../../../graphql/querys/arreglosExtrajudiciales/getAcuerdosExtrajudicialesPorRango.graphql';
import deleteAcuerdoExtrajudicial from '../../../graphql/mutations/arreglosExtrajudiciales/deleteAcuerdoExtrajudicial.graphql';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(deleteAcuerdoExtrajudicial, {
    name: 'deleteAcuerdoExtrajudicial',
  })
)
class ListarAcuerdosExtrajudiciales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lista: [],
      pagina: 1,
      cantidadTotal: 0,
      cantidadPorPagina: 10,
      loading: false,
      loadingTabla: false,
      filtroEstado: null,
      filtroNumero: null,
      filtroNombre: null,
      filtroApellido: null,
      fechaInicial: moment().subtract(7, 'd'),
      fechaFinal: moment(),
    };
  }

  componentDidMount() {
    this.buscarCantidadAcuerdos();
  }

  // Funcion encargada de buscar la cantidad de acuerdos por filtros
  buscarCantidadAcuerdos = () => {
    let filtros = {
      estado: this.state.filtroEstado,
      numero: this.state.filtroNumero,
      nombreRequirente: this.state.filtroNombre,
      apellidoRequirente: this.state.filtroApellido,
    };

    if (this.state.fechaInicial !== '' && this.state.fechaFinal !== '') {
      filtros = {
        ...filtros,
        fechaInicial: this.state.fechaInicial,
        fechaFinal: this.state.fechaFinal,
      };
    }

    this.props.client
      .query({
        query: getCantidadAcuerdosExtrajudicialesConFiltros,
        variables: {
          filtros,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        // console.log('res getCantidad',res.data.getCantidadAcuerdosExtrajudicialesConFiltros);
        this.setState(
          {
            ...this.state,
            cantidadTotal:
              res.data.getCantidadAcuerdosExtrajudicialesConFiltros,
          },
          () => {
            // Llamo a la funcion encargada de hacer la peticion de los acuerdos
            this.lanzarConsulta();
          }
        );
      })
      .catch(err => {
        console.log(err);
      });
  };

  // Funcion encargada de buscar los acuerdos por filtros
  lanzarConsulta = () => {
    this.setState({
      loadingTabla: true,
      loading: true,
    });

    let filtros = {
      estado: this.state.filtroEstado,
      numero: this.state.filtroNumero,
      nombreRequirente: this.state.filtroNombre,
      apellidoRequirente: this.state.filtroApellido,
    };

    if (this.state.fechaInicial !== '' && this.state.fechaFinal !== '') {
      filtros = {
        ...filtros,
        fechaInicial: this.state.fechaInicial,
        fechaFinal: this.state.fechaFinal,
      };
    }

    this.props.client
      .query({
        query: getAcuerdosExtrajudicialesConFiltros,
        variables: {
          filtros,
          pagina: this.state.pagina,
          cantidadPorPagina: this.state.cantidadPorPagina,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        // console.log('Res getAcuerdosConFiltros', lista);

        if (res.data.getAcuerdosExtrajudicialesConFiltros) {
          this.setState({
            lista: res.data.getAcuerdosExtrajudicialesConFiltros,
            loading: false,
            loadingTabla: false,
          });
        }
      })
      .catch(err => {
        console.log('error en getAcuerdosExtrajudicialesConFiltros');
        console.log(err);

        this.setState({
          loadingTabla: false,
          loading: false,
        });
      });
  };

  filtrarPorEstado = async estado => {
    await this.setState(
      {
        ...this.state,
        filtroEstado: estado,
        loading: true,
      },

      () => this.buscarCantidadAcuerdos()
    );
  };

  filtrarPorNumero = async numero => {
    this.setState(
      {
        ...this.state,
        filtroNumero: numero === '' ? null : numero,
        loading: true,
      },
      () => this.buscarCantidadAcuerdos()
    );
  };

  setFiltrarPorAPyN = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas por Nombre y Apellido del requirente
    this.setState(
      {
        ...this.state,
        filtroNombre: filtro.nombreRequirente,
        filtroApellido: filtro.apellidoRequirente,
        loading: true,
      },
      () => this.buscarCantidadAcuerdos()
    );
  };

  onChangeFechas = date => {
    // console.log('DATE: ', date);
    if (date) {
      this.setState(
        {
          fechaInicial: date[0] ? date[0] : '',
          fechaFinal: date[1] ? date[1] : '',
        },
        () => {
          this.buscarCantidadAcuerdos();
        }
      );
    } else {
      this.setState(
        {
          fechaInicial: '',
          fechaFinal: '',
        },
        () => {
          this.buscarCantidadAcuerdos();
        }
      );
    }
  };

  descargarReporte = () => {
    // console.log('entre a descargar reporte');
    let { fechaInicial, fechaFinal } = this.state;

    let filtros = {
      estado: this.state.filtroEstado,
      numero: this.state.filtroNumero,
      nombreRequirente: this.state.filtroNombre,
      apellidoRequirente: this.state.filtroApellido,
      fechaInicial,
      fechaFinal,
    };

    this.props.client
      .query({
        query: getAcuerdosExtrajudicialesPorRango,
        variables: {
          filtros: filtros,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        if (res.data.getAcuerdosExtrajudicialesPorRango) {
          let acuerdos = res.data.getAcuerdosExtrajudicialesPorRango;
          console.log('response descargar', res);

          let data = _.map(acuerdos, acuerdo => {
            return {
              FECHA_CARGA: acuerdo.fechaCreacion
                ? moment(acuerdo.fechaCreacion).format('DD-MM-YYYY HH:mm')
                : '-',
              NUMERO_ACUERDO: acuerdo.numero ? acuerdo.numero : '-',
              ESTADO: acuerdo.estado ? acuerdo.estado : '-',
              REQUIRENTE: acuerdo.requirente
                ? acuerdo.requirente.nombre + ' ' + acuerdo.requirente.apellido
                : '-',
              CANTIDAD_REQUERIDOS: acuerdo.requeridos
                ? acuerdo.requeridos.length
                : '-',
              MOTIVO: acuerdo.motivo ? acuerdo.motivo : '-',
            };
          });
          descargarCSV(
            [
              'Fecha Carga',
              'N° Acuerdo',
              'Estado',
              'Requirente',
              'Cantidadd Requeridos',
              'Motivo',
            ],
            data,
            `AcuerdosExtrajudiciales${moment(fechaInicial).format(
              'DD/MM/YYYY'
            )}-${moment(fechaFinal).format('DD/MM/YYYY')}.csv`
          );
        }
      })
      .catch(err => {
        console.log('TENGO UN ERROR: ', err);
        notification.error({
          message:
            'Error a la hora de generar reporte de acuerdos extrajudiciales',
        });
      });
  };

  onDeleteAcuerdo = id => {
    let yo = this;

    confirm({
      title: '¿Estas seguro de eliminar este Acuerdo Extrajudicial?',
      icon: <Icons.ExclamationCircleFilled />,
      content: 'No podrás revertir los cambios',
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk() {
        yo.setState({ loading: true });

        yo.props
          .deleteAcuerdoExtrajudicial({
            variables: {
              _id: id,
            },
          })
          .then(res => {
            yo.setState(
              {
                loading: false,
              },
              () => yo.buscarCantidadAcuerdos()
            );

            notification.success({
              message: 'El acuerdo se ha eliminado correctamente.',
            });
          })
          .catch(error => {
            console.log('ERROR al eliminar el acuerdo', error);
            yo.setState({
              loading: false,
            });

            notification.error({
              message:
                'Error a la hora de eliminar el acuerdo, intente nuevamente.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.lanzarConsulta();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  render() {
    const usuario = this.props.data.getUsuario;
    const rangoFechas = {
      fechaInicial: this.state.fechaInicial,
      fechaFinal: this.state.fechaFinal,
    };

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Acuerdos Extrajudiciales</Breadcrumb.Item>
          <Breadcrumb.Item>Listar</Breadcrumb.Item>
        </Breadcrumb>
        <TablaAcuerdosExtrajudiciales
          usuario={usuario}
          history={this.props.history}
          acuerdosExtrajudiciales={this.state.lista}
          total={this.state.cantidadTotal}
          cambiarPagina={this.cambiarPagina}
          tamPagina={this.state.cantidadPorPagina}
          cambiarTamañoPagina={this.cambiarTamañoPagina}
          loadingTabla={this.state.loading}
          pagina={this.state.pagina}
          descargarReporte={this.descargarReporte}
          filtroEstadoPadre={this.state.filtroEstado}
          setFiltrarEstado={this.filtrarPorEstado}
          filtroNumeroPadre={this.state.filtroNumero}
          setFiltrarNumero={this.filtrarPorNumero}
          filtroNombrePadre={this.state.filtroNombre}
          filtroApellidoPadre={this.state.filtroApellido}
          setFiltrarPorAPyN={this.setFiltrarPorAPyN}
          onChangeRangoFechas={this.onChangeFechas}
          rangoFechas={rangoFechas}
          onDeleteAcuerdo={this.onDeleteAcuerdo}
        />
      </div>
    );
  }
}

export default withApollo(ListarAcuerdosExtrajudiciales);
